import { defineComponent as _defineComponent } from 'vue'
import { biClick } from '@tencent/fit-bi-sdk';
import { CustomException } from '@tencent/ppd-base-libs';
import { CouponDetail } from '@tencent/wphk-act-base-components';
import { CoreFormatCoupon } from '@tencent/wphk-act-base-framework';
import { copy } from '@tencent/wphk-components-copy';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { hideLoading, showLoading } from '@tencent/wphk-components-loading';
import { FitButton } from '@tencent/wphk-ui';
import { computed, nextTick, ref } from 'vue-demi';
import { getWxShareInfo, handleSetWxShareInfo } from '../../business';
import { useActInfo } from '../../hooks/use-act-info';
import { useHighLogin } from '../../hooks/use-high-login';
import { i18n } from '../../i18n';
import { C2CConfig, C2CCoupon, C2CDialogCouponState, C2CSharerAction, C2CShareType, WxShareInfo } from '../../types';
import CouponList from './coupon-list.vue';
import CouponListSkeleton from './coupon-list-skeleton.vue';
import WxShare from './wx-share.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'share-receive',
  props: {
    c2cConfig: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  c2cConfig: C2CConfig;
}


expose({ onShare });

const wxShareDialog = ref<InstanceType<typeof WxShare> | null>(null);

const couponDetail = ref<InstanceType<typeof CouponDetail> | null>(null);

const shareInfo = ref<WxShareInfo>();

const { checkHighAndLogin } = useHighLogin();

const { c2cCouponList, exchangeCoupon, isAllExchanged } = useActInfo();

const currentCouponItem = ref<C2CCoupon>();

const isExchanging = ref(false);

/** 立即邀請 */
async function onShare(sharerAction = C2CSharerAction.share) {
  try {
    if (!shareInfo.value) {
      await checkHighAndLogin({ shareType: C2CShareType.C2CSharer, sharerAction });
      shareInfo.value = await getWxShareInfo(props.c2cConfig.actInfo.actId);
    }
    if (sharerAction === C2CSharerAction.share) {
      handleSetWxShareInfo({
        link: shareInfo.value.wxShareUrl,
        shareInfo: props.c2cConfig.shareInfo,
      });
      wxShareDialog.value?.showDialog();
    }
    if (sharerAction === C2CSharerAction.copy) {
      // 全部已兑换时候，复制链接时候，默认设置一次微信分享
      // 没有微信分享链接缓存&&没有邀请按钮时候，点击复制链接后直接进行微信分享,如果没有设置就无法分享了
      if (isAllExchanged.value) {
        handleSetWxShareInfo({
          link: shareInfo.value.wxShareUrl,
          shareInfo: props.c2cConfig.shareInfo,
        });
      }
      setTimeout(() => {
        copy(
          {
            text: `${props.c2cConfig.shareInfo.copyContent}${shareInfo.value?.shortUrlForCopy}`,
            fail: (err) => {
              new CustomException(err, 'c2cCopyError', '复制失败');
            },
          },
          '',
        );
      }, 100);
    }
  } catch (error) {
    showBusinessError(error);
  }
}

function onOpenCouponDetail(item: C2CCoupon) {
  currentCouponItem.value = item;
  nextTick(() => {
    couponDetail.value?.showDialog();
  });
}

async function handleExchangeCoupon() {
  const prizeInfo = currentCouponItem.value?.prizeInfo;
  if (!prizeInfo) return;
  if (isExchanging.value) return;
  isExchanging.value = true;
  showLoading();
  couponDetail.value?.hideDialog();
  const { prizeId, exchangeActivityId, exchangePrizeId } = prizeInfo;
  await exchangeCoupon(props.c2cConfig.actInfo.actId, prizeId, exchangeActivityId, exchangePrizeId);
  hideLoading();
  isExchanging.value = false;
}

const dialogExt = computed(() => ({
  fcouponId: currentCouponItem.value?.couponInfo.couponId || '',
  fdialogStatus: currentCouponItem.value?.dialogStatus || '',
}));

async function onBtnClick() {
  biClick('c2c.coupon_dialog_btn', dialogExt.value);
  // 今日已领完，待解锁
  if (currentCouponItem.value?.btnInfo.isDisabled) return;
  // 去使用
  if (currentCouponItem.value?.dialogStatus === C2CDialogCouponState.received) {
    const { userCouponid } = currentCouponItem.value.couponInfo;
    if (userCouponid) {
      if (CoreFormatCoupon.isCpType(currentCouponItem.value)) {
        jumpPage.goCouponDetail({ userScid: userCouponid, adtag: 'shareCoupon' });
      } else {
        jumpPage.goMerchantCouponDetail({ userScid: userCouponid, adtag: 'shareCoupon' });
      }
    }
    new CustomException(userCouponid, 'goUseByEmptyUserscid', '去使用没有用户券 id');
    return;
  }
  // 立即領取
  handleExchangeCoupon();
}

function goToCouponList() {
  jumpPage.goMyCoupons({ adtag: 'c2c' });
}

return { __sfc: true,props, wxShareDialog, couponDetail, shareInfo, checkHighAndLogin, c2cCouponList, exchangeCoupon, isAllExchanged, currentCouponItem, isExchanging, onShare, onOpenCouponDetail, handleExchangeCoupon, dialogExt, onBtnClick, goToCouponList, CouponDetail, copy, FitButton, i18n, C2CDialogCouponState, C2CSharerAction, CouponList, CouponListSkeleton, WxShare }
}

})